import { Monev } from "../../interfaces/Monev";
import { ErrorResponse } from "../../interfaces/ErrorResponse";

const validateMonev = (payload: Monev): ErrorResponse => {
  let errors: ErrorResponse = {
    name: '',
    message: '',
    code: 422,
    status: 422,
    data: []
  };

  if (!payload.EVALUASI_KEGIATAN.replace(/(<([^>]+)>)/gi, "")) {
    errors.data?.push({
      field: "EVALUASI_KEGIATAN",
      message: "Evaluasi kegiatan wajib diisi"
    });
  }

  if (!payload.DESCR_KEGIATAN.replace(/(<([^>]+)>)/gi, "")) {
    errors.data?.push({
      field: "DESCR_KEGIATAN",
      message: "Deskripsi kegiatan wajib diisi"
    });
  }

  if (!payload.LOKASI_KEGIATAN) {
    errors.data?.push({
      field: "LOKASI_KEGIATAN",
      message: "Lokasi kegiatan wajib diisi"
    });
  }

  if (!payload.NAMA_KEGIATAN) {
    errors.data?.push({
      field: "NAMA_KEGIATAN",
      message: "Nama kegiatan wajib diisi"
    });
  }

  if (!payload.TANGGAL_MULAI_KEGIATAN) {
    errors.data?.push({
      field: "TANGGAL_MULAI_KEGIATAN",
      message: "Tanggal mulai kegiatan wajib diisi"
    });
  }

  if (!payload.TANGGAL_SELESAI_KEGIATAN) {
    errors.data?.push({
      field: "TANGGAL_SELESAI_KEGIATAN",
      message: "Tanggal selesai kegiatan wajib diisi"
    });
  }

  if (!payload.PENYELENGGARA_DETAIL || payload.PENYELENGGARA_DETAIL.length === 0) {
    errors.data?.push({
      field: "PENYELENGGARA",
      message: "Penyelenggara wajib diisi, setidaknya harus ada satu penyelenggara"
    });
  }


  if (!payload.PESERTA_KEGIATAN && payload.PESERTA_DETAIL.length === 0) {
    errors.data?.push({
      field: "PESERTA_DETAIL",
      message: "Mohon mengisi atau mengimpor peserta kegiatan."
    });
    errors.data?.push({
      field: "PESERTA_KEGIATAN",
      message: "Mohon mengisi atau mengimpor peserta kegiatan."
    });
  }

  return errors;
}

export default validateMonev;